<template>
    <div id="app">
        <header v-if="showNav()" class="py-1">
            <div class="container">
                <div class="d-flex align-items-center mt-1">
                    <div class="font-weight-bold py-1">
                        <router-link to="/" class="text-dark">
                            <img src="./assets/signature.png" style="height:38px">
                        </router-link>
                    </div>
                    <div class="ml-auto">
                        <img src="./assets/oi_logo.png" style="height: 28px">
                    </div>
                </div>
            </div>
        </header>

        <nav v-if="showNav()"
             class="navbar navbar-light navbar-expand-sm font-weight-bold mb-3 shadow-sm sticky-top bg-white">
            <div class="container">
                <!-- Links -->
                <ul class="navbar-nav menu-sm">
                    <li class="nav-item dropdown">
                        <a class="nav-link dropdown-toggle" href="#" id="navbardrop" data-toggle="dropdown">
                            Menu
                        </a>
                        <div class="dropdown-menu">
                            <router-link to="/home" class="dropdown-item">Dashboard</router-link>
                            <router-link to="/requests" class="dropdown-item">Requests</router-link>
                            <router-link to="/loans" class="dropdown-item">Loans</router-link>
                            <router-link to="/leave" class="dropdown-item">Leave Days</router-link>
                            <router-link to="/notifications" class="dropdown-item">Notifications</router-link>
                            <router-link to="/profile" class="dropdown-item">Profile</router-link>
                        </div>
                    </li>
                </ul>
                <ul class="navbar-nav menu-sm">
                    <logout></logout>
                </ul>

                <ul class="navbar-nav menu-lg">
                    <li class="nav-item">
                        <router-link to="/home" class="nav-link">
                            <ion-icon name="tv-outline" class="icon"></ion-icon>
                            DASHBOARD
                        </router-link>
                    </li>
                    <li class="nav-item">
                        <router-link to="/requests" class="nav-link">
                            <ion-icon name="newspaper-outline" class="icon"></ion-icon>
                            REQUESTS
                        </router-link>
                    </li>
                    <li class="nav-item">
                        <router-link to="/loans" class="nav-link">
                            <ion-icon name="wallet-outline" class="icon"></ion-icon>
                            LOANS
                        </router-link>
                    </li>
                    <li class="nav-item">
                        <router-link to="/leave" class="nav-link">
                            <ion-icon name="calendar-outline" class="icon"></ion-icon>
                            LEAVE DAYS
                        </router-link>
                    </li>
                    <!-- <li class="nav-item">
                        <router-link to="/procurements" class="nav-link">
                            <ion-icon name="list-outline" class="icon"></ion-icon>
                            PROCUREMENT
                        </router-link>
                    </li> -->
                    <li class="nav-item">
                        <router-link to="/notifications" class="nav-link">
                            <ion-icon name="notifications-circle-outline" class="icon"></ion-icon>
                            <sup class="text-success">{{ notifications }}</sup>
                        </router-link>
                    </li>
                </ul>

                <ul class="navbar-nav menu-lg">
                    <li class="nav-item">
                        <logout></logout>
                    </li>
                    <li class="nav-item">
                        <router-link class="nav-link" to="/profile">
                            {{ auth.fname.toUpperCase() }}
                            <ion-icon name="person-outline" class="icon"></ion-icon>
                        </router-link>
                    </li>
                </ul>
            </div>
        </nav>

        <div class="container container-small mb-5">
            <div v-if="!passwordChanged">
                <div class="alert alert-danger alert-dismissible fade show" v-if="changingPassword()">
                    <button type="button" class="close" data-dismiss="alert">&times;</button>
                    <b>Hey {{ auth.fname }}, you need to change your password</b><br>
                    Please
                    <router-link to="/profile/password">click here</router-link>
                    to change your password now!
                </div>

                <div class="alert alert-warning alert-dismissible fade show" v-else>
                    <button type="button" class="close" data-dismiss="alert">&times;</button>
                    Please change your password now!
                </div>
            </div>

            <transition>
                <router-view :auth="auth" @reloadNotificationCount="loadNotificationsCount()"></router-view>
            </transition>

        </div>

        <footer v-if="showNav()" class="container">
            <footer v-if="showNav()" class="footer">
                <div class="row">
                    <div class="col-md-6">
                        <img src="./assets/oi_logo.png" class="mb-2" style="height: 32px">
                        <p>
                            Powered by the <a href="https://openinstitute.africa/" target="_blank">The Open
                            Institute</a> <br>
                        <small class="text-muted">v1.1.10 ~ Jan 06, 2025</small>
                        </p>
                    </div>
                    <div class="col-md-6 text-right">
                        <h6 class="font-weight-bold">Menu</h6>
                        <ul style="list-style: none">
                            <li>
                                <router-link to="/home">Dashboard</router-link>
                            </li>
                            <li>
                                <router-link to="/requests">Requests</router-link>
                            </li>
                            <li>
                                <router-link to="/leave">Leave Requests</router-link>
                            </li>
                        </ul>
                    </div>
                </div>
            </footer>
        </footer>
    </div>
</template>

<script>
import Logout from "@/components/Logout";

export default {
    name: 'App',
    components: {Logout},
    data() {
        return {
            passwordChanged: true,
            notifications: 0,
        }
    },
    computed: {
        auth() {
            return JSON.parse(localStorage.getItem('user'))
        }
    },
    methods: {
        loadNotificationsCount() {
            this.$http.get('/notifications/count').then(res => {
                this.notifications = res.data.data
            })
        },
        changingPassword() {
            return this.$router.currentRoute.path !== '/profile/password'
        },
        showNav() {
            let i = this.$router.currentRoute.path
            return (i !== '/verify' && i !== '/login' && i !== '/recover' && i !== '/error')
        }
    }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;700&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Oxanium:wght@700&display=swap');
@import url("https://fonts.googleapis.com/css2?family=Baloo+Da+2:wght@400;700&display=swap");


* {
    padding: 0;
    margin: 0;
}

html {
    scroll-behavior: smooth;
}

body {
    line-height: 1.6;
    text-rendering: optimizeLegibility;
    -moz-osx-font-smoothing: grayscale;
    color: #14161c;
    font-size: 0.875rem !important;
    font-family: 'Inter', sans-serif !important;
    background: linear-gradient(to right, #fafafa, #f2f6ff);;
}

a {
    color: #42B4FF;
}

ul, ol {
    margin-left: 0 !important;
}

.btn {
    border-radius: 20px !important;
    border-color: #42B4FF !important;
    border-width: 2px !important;
    font-size: 0.88rem !important;
    color: #42B4FF !important;
    font-weight: bold !important;
    margin-right: 2px;
    background-color: transparent !important;
}

.btn:hover {
    color: #42B4FF;
    opacity: .8;
    background-color: transparent !important;
    transition: all 0.3s ease-in;
}

.rounded-lg {
    border-radius: 20px !important; /* Adjust the value as needed */
}

.footer {
    padding-top: 20px;
}

h2, h3, h4, h5 {
    font-weight: bold;
    font-family: "Baloo Da 2", Inter, sans-serif;
}

table a {
    color: #42B4FF;
}

ul, ol {
    list-style-position: inside;
    margin-left: 8px;
}

.container {
    min-width: 900px !important;
    max-width: 900px !important;
}

input, textarea, select {
    /*border-radius: 2px !important;*/
    border-color: #eee !important;
}

a:hover {
    text-decoration: none !important;
}

.narration p, .narration ul {
    margin: 0 0 2px 0 !important;
}

.narration ul {
    list-style-type: square;
    list-style-position: inside;
}

.narration ul li {
    margin-left: 10px;
}

.dash .nav-link {
    font-weight: bold !important;
}

.font {
    color: #42B4FF !important;
    font-family: Oxanium, sans-serif !important;
}

.table thead th {
    border: none !important;
}

.table tbody tr:first-child > td {
    border-top: none;
}

.table-striped tbody tr:nth-of-type(2n+1) {
    background-color: #f4f4fe !important;
}

.loans {
    column-gap: 10px !important;
}

.requests td {
    border-top: none !important;
}

.form-control {
    font-size: inherit !important;
}

.navbar-light .navbar-nav .nav-link {
    color: #333;
    font-size: 1.10em;
    font-family: "Baloo Da 2", sans-serif;
}

.navbar-light .icon {
    font-size: 20px;
    margin-right: 2px;
    vertical-align: -4px;
}

.navbar-light .navbar-nav .nav-link.active {
    color: #42B4FF !important;
    font-weight: bolder !important;
}

input, textarea, select, button {
    /*border-radius: 0 !important;*/
    /*border-color: #bfdaf4 !important;*/
}

.highlight {
    font-size: 0.86em;
    padding: 3px 12px;
    font-weight: bolder;
    border: 1px solid #eee;
    background-color: #f2f6ff !important;
    color: #567e85 !important;
    border-radius: 10px;
}

.highlight:hover {
    transition: .2s all;
    opacity: .8;
}

.status {
    font-size: 0.88em;
    padding: 4px 16px;
    font-weight: bolder;
    background-color: #ffffff;
    border-radius: 20px;
    white-space: nowrap;
}

.status-sm {
    padding: 1px 4px !important;
    font-size: 0.8em !important;
}

.status::before {
    content: '';
    background: #999;
    width: 8px;
    height: 8px;
    border-radius: 60%;
    position: relative;
    right: 3px;
    display: inline-block;
}

.status.declined {
    color: #dc3545;
    border:2px solid #dc3545 !important;
}

.status.authorized, .status.partial {
    color: teal;
    background-color: transparent !important;
    border: 2px solid teal !important;
}

.status.authorized:before, .status.partial:before {
    background: teal;
}

.status.approved {
    color: #2e6531;
    border: 2px solid #2e6531 !important;
}

.status.approved:before {
    background: #2e6531;
}

.status.verified, .status.paid, .status.completed, .status.online {
    color: #42B4FF !important;
    background-color: #fff !important;
    border:2px solid #42B4FF !important;
}

.status.verified::before, .status.paid::before, .status.completed::before, .status.online::before {
    background-color: #42B4FF !important;
}

.status.verified:before, .status.paid:before, .status.online:before {
    background: #fff;
}

.status.disbursed, .status.active {
    color: #28a745 !important;
    background-color: #fff !important;
    border: 2px solid #28a745 !important;
}

.status.disbursed::before, .status.active::before {
    background: #28a745;
}

.status.pending {
    border: 2px solid #999 !important;
}

.status.closed {
    border: 2px solid #ddd !important;
}

.status.closed::before {
    background: #42B4FF;
}

.blink {
    animation: blinker 1s linear infinite;
}

.grid-container {
    display: grid;
    grid-auto-rows: 1fr;
    grid-column-gap: 10px;
    grid-template-columns: auto auto auto;
}

.grid-item {
    padding: 10px;
    margin-bottom: 10px;
    border-radius: 2px;
    text-align: center;
    border: 1px solid #eee;
}

.grid-item:hover {
    border-color: #999;
}

.menu-sm {
    display: none !important;
}

@keyframes blinker {
    50% {
        opacity: .4;
    }
}

.fade-enter-active, .fade-leave-active {
    transition: opacity 0.5s;
}

.fade-enter, .fade-leave-to {
    opacity: 0;
}

@media only screen and (max-width: 480px) {
    .container {
        min-width: 100% !important;
        max-width: 100% !important;
    }

    body {
        font-size: 0.82em !important;
    }

    .menu-sm {
        display: block !important;
    }

    .menu-lg {
        display: none !important;
    }

    .p-4 {
        padding: 10px !important;
    }

    .sh {
        display: none !important;
    }

    .request {
        flex-direction: column;
    }

    .request-profile {
        display: none !important;
    }

    .container {
        padding-left: 10px !important;
        padding-right: 10px !important;
    }

    .btn-sm {
        padding: 0.20rem 0.25rem !important;
        font-size: 0.70rem !important;
    }

    .grid-container {
        display: block;
    }
}
</style>
